<template>
  <el-popconfirm title="Are you sure you want to modify the status?" confirmButtonText="Yes" cancelButtonText="No"
    v-if="status == 0" @confirm="updateStatusEvent(id, 1, type)">
    <el-button :disabled='disabled' size="mini" type="primary" slot="reference" style="width:110px">Submit
    </el-button>
  </el-popconfirm>
  <el-row v-else-if="status == 1">
    <el-col :span="13" v-if="checkPermission(approval)">
      <el-popconfirm title="Are you sure you want to modify the status?" confirmButtonText="Yes" cancelButtonText="No"
        @confirm="handleApprove">
        <el-button :disabled='disabled' class="el-button-blue" size="mini" type="primary" slot="reference"
          style="width:110px">Approve
        </el-button>
      </el-popconfirm>
    </el-col>
    <el-col :span="11" v-if="checkPermission(approval)">
      <el-popconfirm title="Are you sure you want to modify the status?" confirmButtonText="Yes" cancelButtonText="No"
        @confirm="updateStatusEvent(id, 3, type)">
        <el-button :disabled='disabled' class="el-button-blue" size="mini" type="primary" slot="reference"
          style="width:110px">Reject
        </el-button>
      </el-popconfirm>
    </el-col>
    <el-popconfirm title="Are you sure you want to modify the status?" confirmButtonText="Yes" cancelButtonText="No"
      @confirm="updateStatusEvent(id, 0, type)">
      <el-button :disabled='disabled' size="mini" style="margin-top:10px;width:110px" type="primary"
        slot="reference">Cancel
      </el-button>
    </el-popconfirm>
  </el-row>
  <el-popconfirm v-else-if="status == 2 && checkPermission(approval)"
    title="Are you sure you want to modify the status?" confirmButtonText="Yes" cancelButtonText="No"
    @confirm="updateStatusEvent(id, 1, type)">
    <el-button :disabled='disabled' size="mini" class="el-button-blue" style="margin-top:10px;width:110px"
      type="primary" slot="reference">Cancel
    </el-button>
  </el-popconfirm>
  <el-popconfirm title="Are you sure you want to modify the status?" confirmButtonText="Yes" cancelButtonText="No"
    v-else-if="status == 6 && checkPermission(approval)" @confirm="updateStatusEvent(id, 5, type)">
    <el-button :disabled='disabled' class="el-button-blue" size="mini" type="primary" slot="reference"
      style="width:110px">Suspend
    </el-button>
  </el-popconfirm>
  <el-popconfirm title="Are you sure you want to modify the status?" confirmButtonText="Yes" cancelButtonText="No"
    v-else-if="status == 5 && checkPermission(approval)" @confirm="updateStatusEvent(id, 6, type)">
    <el-button :disabled='disabled' class="el-button-blue" size="mini" type="primary" slot="reference"
      style="width:110px">Cancel
    </el-button>
  </el-popconfirm>
</template>
<script>
import config from "../../config";
export default {
  name: "StatusController",
  mixins: [config.globalMixin],
  data() {
    return {
    };
  },
  props: {
    id: "",
    status: "",
    init: null,
    type: "",
    approval: "",
    disabled: false
  },
  methods: {
    handleApprove() {
      // 如果父组件监听了approve-click，则只emit，不走原逻辑
      if (this.$listeners['approve-click']) {
        this.$emit('approve-click', { id: this.id, status: this.status, type: this.type });
      } else {
        this.updateStatusEvent(this.id, 2, this.type);
      }
    },
    async updateStatusEvent(id, status, type, answer, captcha, captchaId) {
      var objdata = this.getAuthObj();
      objdata.audit = {};
      objdata.audit.id = id;
      objdata.audit.status = status;
      objdata.audit.type = type;
      objdata.apiUrl = this.apiConfig.systemApproveUpdate;
      // if (answer !== undefined && captcha !== undefined && captchaId !== undefined) {
      //   objdata.answer = answer;
      //   objdata.captcha = captcha;
      //   objdata.captchaId = captchaId;
      // }
      let data = await this.$store.dispatch("apiEvent", objdata);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      this.init()
      if (!data) return;
      return data
    }
  },
  mounted() {
    // this.init();
  },
};
</script>
